import Vue from 'vue';
import Vuex from 'vuex';
import auth from "./modules/auth";
import lesson from "./modules/lesson";
import profile from "./modules/profile";
import language from "./modules/language";
import uselevel from "./modules/uselevel";
import {appName, api} from './../config';
import createPersistedState from "vuex-persistedstate";

import { mergeLocaleMessage } from './../i18n/helpers'

Vue.use(Vuex);

export default new Vuex.Store({
  data () {
  },
  state: {
    errors: [],
    loading: false,
    newslist: [],
    unreadnews: [],
    playing_audio_list: {},
    inquirylist: [],
  },
  getters: {
    errors: state => state.errors,
    isLoading: state => {
      return state.loading
    },
    newslist: state => {
      return state.newslist
    },
    unreadnews: state => {
      return state.unreadnews
    },
    inquirylist: state => {
      return state.inquirylist
    },
  },
  mutations: {
    setErrors(state, errors) {
      state.errors = errors;
    },
    setLoading (state, toggle) {
      state.loading = toggle
    },
    setNewslist (state, data) {
      state.newslist = data
    },
    setUnreadNews (state, data) {
      state.unreadnews = data
    },
    addPlayingAudio (state, { name, audio }) {
      Vue.set(state.playing_audio_list, name, audio)
    },
    removePlayingAudio (state, name) {
      Vue.delete(state.playing_audio_list, name)
    },
    setInquirylist (state, data) {
      state.inquirylist = data
    },
  },
  actions: {
    showLoading ({ commit }, toggle) {
      commit('setLoading', toggle)

      const cookieConsent = document.getElementsByClassName('js-cookie-consent');
      if(cookieConsent && cookieConsent.length) {
        // get cookie
        let cookieVal;
        let cookie = document.cookie;
        let cookieObj = {};
        if(!!cookie){
          Array.prototype.forEach.call(cookie.split(';'),function(c){
           let array = [c][0].split('=').map(function(a){return a.trim()});
           let key = ~c.indexOf('=')? unescape(array[0]) : '';
           let val = ~c.indexOf('=')? unescape(array[1]) : unescape(array[0]);
           if(!cookieObj.hasOwnProperty(key)){
             cookieObj[key] = [val];
           }else{
             cookieObj[key].push(val);
           }
          });
        }

        if(cookieObj.hasOwnProperty('jslmethod_cookie_consent')){
          cookieVal = cookieObj['jslmethod_cookie_consent'];
        }

        if(cookieVal === undefined || !cookieVal) {
          // 未設定なら表示非表示操作
          if(toggle) {
            cookieConsent[0].style.display = 'none';
          } else {
            cookieConsent[0].style.display = 'block';
          }
        } else {
            cookieConsent[0].style.display = 'none';
        }
      }
    },
    mergeLocaleMessage ({ state }, data) {
      mergeLocaleMessage(state, data)
    },
    getNewsList({ commit, state, dispatch }) {
      axios.get(api.unreadnews)
        .then((resp) => {
          commit('setUnreadNews', resp.data)
        })

      return axios.get(api.newsList)
          .then((resp) => {
            commit('setNewslist', resp.data)
            dispatch('mergeLocaleMessage', { newslist: resp.data })
          })

    },
    getInquiryList({ commit, state, dispatch }) {
      return axios.get(api.inquiryList)
          .then((resp) => {
            commit('setInquirylist', resp.data)
          })
    },
    clearInquiryList({ commit }) {
      commit('setInquirylist', [])
    },
    playSoundEffect({ state, dispatch }, name) {
      return dispatch('playAudioUrl', { name, url: _.get(window.soundeffects, name) })
    },
    playAudioUrl({ state, commit, getters }, { name, url }) {
      // // 'touch'は再生中のAudioがある場合は再生しない
      // if (name == 'touch' && getters.is_playing_audio) return Promise.resolve()
      // 再生中の同じnameのAudioを停止
      let playingAudio = _.get(state.playing_audio_list, name)
      if (playingAudio) {
        playingAudio.pause();
        playingAudio.currentTime = 0;
        playingAudio.play();
      } else {
        playingAudio = new Audio(url)
        commit('addPlayingAudio', { name: name , audio: playingAudio })
        
        playingAudio.muted = true;
        let playPromise = playingAudio.play();
        playPromise.then(() => {
          playingAudio.pause();
          playingAudio.muted = false;
          playingAudio.currentTime = 0;

          playingAudio.play();

        })
      }

      return Promise.resolve();
    },
  },
  modules: {
    auth,
    lesson,
    profile,
    language,
    uselevel,
  },
  plugins: [createPersistedState({
    key: appName,
    paths: [
      'auth',
      'lesson',
      'profile',
      'language',
      'uselevel',
    ],
    storage: window.sessionStorage
  })] ,
  strict: true
});